import { Dialog, DialogContent } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid-premium";
export var MuiImagePopUp = function (props) {
    var onClose = props.onClose, isOpen = props.isOpen, image = props.image;
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: isOpen,
        onClose: onClose,
        fullWidth: true,
        sx: {
            background: 'none',
            width: '100%',
            height: '100%',
            zIndex: 1300
        }
    }, /*#__PURE__*/ React.createElement(DialogContent, {
        style: {
            padding: 0,
            display: 'flex',
            justifyContent: 'center'
        }
    }, image && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(GridCloseIcon, {
        id: "img-close-btn",
        onClick: onClose,
        sx: {
            position: 'absolute',
            zIndex: 1,
            right: 10,
            top: 8,
            color: 'white',
            height: '20px',
            width: '20px',
            borderRadius: 50
        }
    }), /*#__PURE__*/ React.createElement("img", {
        src: image,
        width: '100%',
        height: "100%",
        alt: "close"
    }))));
};
